export const isTomanCurrency = (currency) => {
  const values = [
    currency?.currency_symbol,
    currency?.currency_code,
    currency?.currency_name,
    currency?.name,
  ].map((value) => String(value || '').trim().toLowerCase());

  return values.some((value) => value === 'تومان' || value === 'toman' || value === 'irt');
};

export const getDefaultCurrencyId = (currencies = []) => {
  if (!Array.isArray(currencies) || currencies.length === 0) return undefined;
  return (currencies.find(isTomanCurrency) || currencies[0])?.id;
};

/** برچسب یکدست ارز در انتخابگرها: تومان فارسی؛ سایر ارزها «نام (نماد)» */
export const currencyLabel = (currency) => {
  if (!currency) return '—';
  if (isTomanCurrency(currency)) return 'تومان';
  const name = currency.currency_name || currency.name || '';
  const symbol = currency.currency_symbol || '';
  if (name && symbol && name !== symbol) return `${name} (${symbol})`;
  return name || symbol || currency.currency_code || '—';
};
